import GetBrowserData from './GetBrowserData';

export default GetBrowserData;
